if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"help-centre","remotes":[{"alias":"core","name":"core","entry":"https://core.mancity.com/_next/static/chunks/remoteEntry.js","shareScope":"default","externalType":"script"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(7(0|54|86)|163|264|477|509|623|698|955)$/.test(chunkId)},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {"core":[{"alias":"core","name":"core","entry":"https://core.mancity.com/_next/static/chunks/remoteEntry.js","shareScope":"default","externalType":"script"}]}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}